<template>
  <div class="flex flex-grow">
    <ul class="nav nav-pills hidden relative xl:order-first xl:flex xl:flex-col flex-shrink-0 w-72 pr-4 pb-6" v-if="showNav">
      <li :class="{ 'nav-item' : true, 'active': tab.show }" v-for="(tab, tabId) in tabs" :key="tabId">
        <a :href="'#' + tabId" :class="{ 'nav-link' : true }" @click.stop="setActive(tab)">{{ tab.title }}</a>
      </li>
    </ul>
    <div class="tab-content flex-1 focus:outline-none xl:order-last min-w-0">
      <slot></slot>
    </div>
  </div>
</template>
<script>
import { reactive, provide } from 'vue'
let tabsCnt = 0

export default {
  props: {
    showNav: {
      type: Boolean,
      default: true
    }
  },
  setup () {
    const tabs = reactive({})
    let activeTabId = null
    let activeTabHash = null

    if (window?.location?.hash) {
      activeTabHash = window.location.hash.substring(1)
    }

    provide('addTab', (title, active, id = null) => {
      const tab = {
        title,
        id: id || 'tab_' + (tabsCnt++),
        show: active
      }

      if ((activeTabHash === tab.id || active) && activeTabId) {
        tabs[activeTabId].show = false
      }

      if (active && (activeTabId === null || activeTabId !== activeTabHash)) {
        activeTabId = tab.id
      } else if (activeTabHash === tab.id) {
        tab.show = true
        activeTabId = tab.id
      } else {
        tab.show = false
      }

      tabs[tab.id] = tab
      return tabs[tab.id]
    })

    const setActive = (tab) => {
      if (activeTabId) {
        tabs[activeTabId].show = false
      }

      activeTabId = tab.id
      tab.show = true
    }

    return {
      tabs,
      setActive,
    }
  }
}
</script>
